import * as Yup from 'yup'

export const createInsuranceCoverageSchema = (requireDocumentUploadWhenOptedIn?: boolean) => {
  return Yup.object({
    type: Yup.string()
      .oneOf(['gigsafe', 'own'], 'Selecting an answer is required.')
      .required('Selecting an answer is required.'),
    files: Yup.array()
      .nullable()
      .when('type', {
        is: 'own',
        then: () =>
          Yup.array()
            .nullable()
            .min(1, 'At least one file is required.')
            .test('required-files', 'At least one file is required.', (value) => {
              return value !== null && value !== undefined && value.length > 0
            }),
        otherwise: () =>
          requireDocumentUploadWhenOptedIn
            ? Yup.array()
                .nullable()
                .min(1, 'At least one file is required.')
                .test('required-files', 'At least one file is required.', (value) => {
                  return value !== null && value !== undefined && value.length > 0
                })
            : Yup.array().nullable().notRequired(),
      }),
  })
}
